// extracted by mini-css-extract-plugin
export default {"skeleton-grid":"Automations_skeleton-grid__SEGxw","loadingSpinner-container":"Automations_loadingSpinner-container__WM6W2"};